import {applyMiddleware, createStore, combineReducers} from "redux";
import {reducer as formReducer} from 'redux-form';
import promise from 'redux-promise'
import thunk from 'redux-thunk'

import createSagaMiddleware from "redux-saga"
import rootSaga from "../sagas/rootSaga";

import userReducer from "./reducers/usersScreenReducer";
import userLoginReducer from "./reducers/userLoginReducer";
import partnerReducer from "./reducers/partnerReducer";
import applicationReducer from "./reducers/applicationReducer";
import moduleReducer from "./reducers/moduleReducer";
import roleReducer from "./reducers/roleReducer";
import loadingReducer from "./reducers/appLoadingReducer"
import certificationReducer from "./reducers/certificationReducer"
import usersReducer from "./reducers/usersReducer"
import accessManagementReducer from "./reducers/accessManagementReducer"

const reducers = combineReducers({
    loading: loadingReducer,
    usersScreen: userReducer,
    userLogin: userLoginReducer,
    partner: partnerReducer,
    application: applicationReducer,
    module: moduleReducer,
    role: roleReducer,
    form: formReducer,
    certification: certificationReducer,
    users: usersReducer,
    accessManagement: accessManagementReducer,
});

const sagaMiddleware = createSagaMiddleware();

const devTootls = window.__REDUX_DEVTOOLS_EXTENSION__
    && window.__REDUX_DEVTOOLS_EXTENSION__();
const store = applyMiddleware(sagaMiddleware, thunk, promise)(createStore)(reducers, devTootls);

sagaMiddleware.run(rootSaga);
export default store;
